import {
  FETCH_KNOWLEDGE_CHECK_FAILURE,
  FETCH_KNOWLEDGE_CHECK_REQUEST,
  FETCH_KNOWLEDGE_CHECK_SUCCESS,
  HIDE_KNOWLEDGE_CHECKS,
  POST_KNOWLEDGE_CHECK_FAILURE,
  POST_KNOWLEDGE_CHECK_REQUEST,
  POST_KNOWLEDGE_CHECK_SUCCESS,
  GET_SECTION_BY_SCREENER_FROM_MENU,
  CANCEL_SCREENER,
  RESET_CURRENT_SCREENER,
} from '../types/knowledgeCheckTypes';
import { getUserToken } from '../../services/localStorage';
import { BASE_API_URL } from '../../constants/constants';
import { requestGetApi } from '../../services/api/api';
import { getSectionById } from './sectionActions';

const fetchKnowledgeCheckRequest = () => ({
  type: FETCH_KNOWLEDGE_CHECK_REQUEST,
});

const fetchKnowledgeCheckSuccess = (screener) => ({
  type: FETCH_KNOWLEDGE_CHECK_SUCCESS,
  payload: screener,
});

const fetchKnowledgeCheckFailure = (error) => ({
  type: FETCH_KNOWLEDGE_CHECK_FAILURE,
  payload: error,
});

export const getSectionByScreenerFromMenu = (section_id) => ({
  type: GET_SECTION_BY_SCREENER_FROM_MENU,
  payload: section_id,
});

export const openScreenerFromMenu = (id) => {
  return async (dispatch) => {
    dispatch(getScreenerById(id));
  };
};

export const getScreenerById = (id = 0) => {
  return async (dispatch, getState) => {
    if (id === 0) {
      dispatch(onSelectCurrentScreener(undefined));
      return;
    }

    const { sections } = getState().section;
    const { currentScreener: currentScreener } = getState().knowledgeCheck;

    // if currentScreener already exists
    // avoid to do the search again
    if (currentScreener && id === currentScreener.id) {
      dispatch(onSelectCurrentScreener({ ...currentScreener }));
      return;
    }

    // search in sections if current screener exists
    if (sections && sections.length) {
      let findScreener = undefined;
      sections.forEach((section) => {
        section.items.forEach((screener) => {
          if (screener.id === id) {
            findScreener = screener;
          }
        });
      });

      if (findScreener) {
        dispatch(onSelectCurrentScreener({ ...findScreener }));
        return;
      }
    }

    try {
      dispatch(fetchKnowledgeCheckRequest());
      const screener = await requestGetApi(
        `${BASE_API_URL}/screeners/${id}`
      );
      dispatch(onSelectCurrentScreener({ ...screener }));
    } catch (error) {
      dispatch(fetchKnowledgeCheckFailure(error.toString()));
    }
  };
};

export const hideKnowledgeCheck = () => ({
  type: HIDE_KNOWLEDGE_CHECKS,
});

export const postKnowledgeCheckRequest = () => ({
  type: POST_KNOWLEDGE_CHECK_REQUEST,
});

export const postKnowledgeCheckSuccess = (
  knowledgeCheckAnswers,
  answersList,
  screenerDone,
  currentScreener
) => ({
  type: POST_KNOWLEDGE_CHECK_SUCCESS,
  payload: { knowledgeCheckAnswers, answersList, screenerDone, currentScreener },
});

export const postKnowledgeCheckFailure = (error) => ({
  type: POST_KNOWLEDGE_CHECK_FAILURE,
  payload: error,
});

export const fetchKnowledgeCheckByKCid = (knowledge_check_id) => {
  return async (dispatch) => {
    try {
      const token = getUserToken();
      const headers = {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      };

      dispatch(fetchKnowledgeCheckRequest());
      const response = await fetch(
        `${BASE_API_URL}/knowledge_checks?knowledge_check_id=${knowledge_check_id}`,
        headers
      );

      if (!response.ok) dispatch(fetchKnowledgeCheckFailure(response.status));

      const knowledgeCheckResponse = await response.json();
      const knowledgeCheck = knowledgeCheckResponse.knowledge_checks;
      dispatch(fetchKnowledgeCheckSuccess(knowledgeCheck || []));
    } catch (error) {
      dispatch(fetchKnowledgeCheckFailure(error));
    }
  };
};

export const fetchKnowledgeCheck = (module_section_id) => {

  return async (dispatch) => {
    try {
      const token = getUserToken();
      const headers = {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      };

      dispatch(fetchKnowledgeCheckRequest());
      const response = await fetch(
        `${BASE_API_URL}/knowledge_checks?module_section_id=${module_section_id}`,
        headers
      );

      if (!response.ok) dispatch(fetchKnowledgeCheckFailure(response.status));

      const knowledgeCheckResponse = await response.json();
      const knowledgeCheck = knowledgeCheckResponse.knowledge_checks;
      dispatch(fetchKnowledgeCheckSuccess(knowledgeCheck || []));
    } catch (error) {
      dispatch(fetchKnowledgeCheckFailure(error));
    }
  };
};

export const submitKnowledgeCheck = (
  knowledgeContent,
  answersList,
  isScreener
) => {
  return async (dispatch) => {
    if (isScreener === true) {
      dispatch(postKnowledgeCheckRequest());
      dispatch(postKnowledgeCheckSuccess([], answersList, true));
      return;
    }

    const token = getUserToken();
    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    };
    const requestOptions = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ knowledge_check_answers: knowledgeContent }),
    };
    try {
      dispatch(postKnowledgeCheckRequest());
      const response = await fetch(
        `${BASE_API_URL}/knowledge_check_answers`,
        requestOptions
      );

      if (!response.ok) throw new Error(response.status);
      const knowledge_check_answers = await response.json();
      dispatch(
        postKnowledgeCheckSuccess(
          knowledge_check_answers || [],
          answersList,
          false
        )
      );
    } catch (error) {
      dispatch(postKnowledgeCheckFailure(error));
    }
  };
};

export const onSelectCurrentScreener = (screener) => {

  return async (dispatch) => {
    dispatch(fetchKnowledgeCheckSuccess(screener));
    if (!screener) return;

    // is section exists
    // set section parent
    if (screener.module_section) {
      dispatch(getSectionById(screener.module_section.id, true));
    } else if (screener.module_section_id) {
      dispatch(getSectionById(screener.module_section_id, true));
    }
  };
};

export const cancelScreener = (cancel) => ({
  type: CANCEL_SCREENER,
  payload: cancel,
});

export const resetCurrentScreener = () => ({
  type: RESET_CURRENT_SCREENER,
});